import { Carousel } from "../components/Carousel";
import { iniciosSlides } from "../data/content";

export function VidaSection() {
	return (
		<section className="section" id="vida">
			<div className="content-wrap reveal">
				<div className="section__label">Una vida dedicada</div>
				<h2 className="section__heading">
					Para quienes la conocimos, Stefanny siempre será un faro de luz.
				</h2>
				<div className="body-text">
					<p>
						Esta página está dedicada a la vida y trabajo de Stefanny Daniela Mora
						Nieto, gran activista, luchadora por los derechos de la mujer y una
						gran persona. Que la luz y el fuego de su vida no queden relegados al
						tiempo y espacio donde y cuando ella vivía, que continúe a través de
						quienes la amábamos y compartíamos su visión e ideales. A su vez,
						también hacemos mención de nuestros hijos, <b>Damián Quintanar Mora</b> y
						<b>Dorian Quintanar Mora</b>.
					</p>
				</div>
				<div className="pull-quote">
					<div className="pull-quote__text">
						Siempre dispuesta a ayudar, a velar por la justicia y dar lo mejor de
						sí para sus amigas y amigos, a quienes consideró como su familia.
					</div>
					<div className="pull-quote__attr">— En su memoria</div>
				</div>
			</div>
			<div className="content-wrap--wide">
				<Carousel slides={iniciosSlides} title="Inicios" />
			</div>
		</section>
	);
}
